import { Button, Checkbox, TextField, Typography } from '@arionbanki/arionui';
import { Markdown } from 'components';
import { classNames } from 'helpers';
import imgSecondary from 'img/gold.jpg';
import imgPrimary from 'img/login_bg.svg';
import { useAuthenticate } from './useAuthenticate';

export function Authenticate() {
	const { config, isManualSignCompany, flowType, formErrors, onSubmit, t, ...props } = useAuthenticate();
	return (
		<div className="row my-5">
			<div className="col-12 col-md-6 d-md-none mb-5">
				<Images />
			</div>
			<div className="col-12 col-md-6">
				<Typography className="mb-4" TagName="h3">
					{t(`${flowType}_title`, 'authentication', true)}
				</Typography>
				<Typography TagName="p">{t(`${flowType}_main`, 'authentication', true)}</Typography>
				<form className="mb-4 auth" onSubmit={onSubmit}>
					{config.IS_EMPLOYEE_WEB && (
						<TextField
							error={!!formErrors?.kennitala}
							label={t('kennitala')}
							message={formErrors?.kennitala}
							name="kennitala"
						/>
					)}
					<TextField
						error={!!formErrors?.phone}
						label={config.IS_EMPLOYEE_WEB ? t('phone') : t('phoneOrKennitala')}
						message={formErrors?.phone}
						name="phone"
					/>
					<TextField
						error={!!formErrors?.email}
						label={t('email')}
						message={formErrors?.email}
						name="email"
					/>
					{config.IS_EMPLOYEE_WEB && (
						<>
							<div className={classNames('mt-4', { 'mb-4': !isManualSignCompany })}>
								<Checkbox
									checked={isManualSignCompany}
									id="isManualSignCompany"
									label={t('is_company_kennitala')}
									name="isManualSignCompany"
									onChange={() => props.setIsManualSignCompany(!isManualSignCompany)}
								/>
							</div>
							{isManualSignCompany && (
								<TextField
									error={!!formErrors?.companyKennitala}
									label={t('company_kennitala', 'general')}
									message={formErrors?.companyKennitala}
									name="companyKennitala"
								/>
							)}
						</>
					)}
					{props.SHOW_COSTS_FOR_FLOW_TYPES[`${flowType}`] && (
						<div className="arionui text-small my-4">
							<Markdown>{t('portfolio_costs')}</Markdown>
						</div>
					)}
					<Button className="mt-5" size="large" width="100%">
						{t('submit')}
					</Button>
				</form>
				<div className="arionui text-small">
					<Markdown>{t('mv_authentication_privacy_policy', 'authentication')}</Markdown>
				</div>
			</div>
			<div className="col-12 col-md-6 d-none d-md-block">
				<Images />
			</div>
		</div>
	);
}

function Images() {
	return (
		<>
			<img alt="" className="w-100 primary" src={imgPrimary} />
			<div className="h-100 w-100 secondary auth-img-secondary">
				<img alt="" className="w-75" src={imgSecondary} />
			</div>
		</>
	);
}
